import { Dialog } from "@mui/material";
import { useState } from "react";
import MultipleChipsField from "../../BaseInputs/MultipleChipsField";
import { ICultura} from "../../../screens/ReceituarioAgronomico/components/MICulturas/ListarCulturas/Listagem";
import DialogContentSelectGeneric from "../DialogsContents/DialogContentGeneric";

interface SelectCulturaReceituarioProps {
    value: ICultura | ICultura[] | null;
    onChange: (arg: ICultura | ICultura[] | null) => void;
    error?: boolean;
    required?: boolean;
    unique_select?: boolean;
    agrotoxico_id?: number;
}

export default function SelectCultura({
                                                     value,
                                                     onChange,
                                                     required = false,
                                                     error = false,
                                                     unique_select = false,
                                                     agrotoxico_id,
                                                 }: SelectCulturaReceituarioProps) {
    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => setOpenModal(false);

    // Normalize value for chips field
    const normalizedValue = value
        ? Array.isArray(value)
            ? value
            : [value]
        : [];

    return (
        <>
            <MultipleChipsField
                value={normalizedValue}
                label="Cultura"
                required={required}
                formatChipLabel={(item) => `${item.id} - ${item.nome}`}
                onClick={() => setOpenModal(true)}
                error={!!error}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {openModal && (
                <Dialog
                    fullWidth
                    maxWidth="md"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        handleClose={handleClose}
                        multiple={!unique_select}
                        possuiBtnLimpar
                        title="Selecionar Cultura"
                        queryPath="/receituario-agronomico/culturas/pesquisar-cultura"
                        getItemKey={(item: any) => item?.id ?? 0}
                        getItemLabel={(item: any) => item ? `${item.id} - ${item.nome}` : ''}
                        defaultValue={normalizedValue}
                        onChange={(selected: any) => {
                            if (unique_select) {
                                const arr = Array.isArray(selected) ? selected : selected ? [selected] : [];
                                onChange(arr.length > 0 ? arr[0] : null);
                            } else {
                                onChange(Array.isArray(selected) ? selected : selected ? [selected] : []);
                            }
                            handleClose();
                        }}
                    />
                </Dialog>
            )}
        </>
    );
}